module.exports = __webpack_public_path__ + "img/img40.35538585.jpg";